export enum QueryKey {
  AUTH = "auth",
  BACKUPS = "backups",
  DIAGNOSTIC_IMAGES = "diagnostic-images",
  DIAGNOSTICS = "diagnostics",
  DRAWINGS = "drawings",
  FIELD_OBSERVATIONS = "field-observations",
  FIELD_PARTS = "field-parts",
  FIELD_PART_TEMPLATES = "field-part-templates",
  AUDIO_RECORDINGS = "audio-recordings",
  DRAWING_BRANCHES = "drawing-branches",
  DRAWINGS_IMAGES = "drawings-images",
  EVENT_LOGS = "event-logs",
  LEGENDS = "legends",
  LICENSE_SUMMARY = "license-summary",
  METADATA_DETECTORS = "metadata-detectors",
  ORGANIZATIONS = "organizations",
  PROJECTS = "projects",
  REPORT_TEMPLATE = "report-template",
  REPORTS = "reports",
  SECTIONS = "sections",
  USERS = "users",
  FILE = "file",
  FINDINGS = "findings",
  REPORT_IMAGES = "report-images",
  CATALOGUES = "catalogues",
  DISORDER_TEMPLATES = "disorder-templates",
}
